module.exports = __webpack_public_path__ + "img/H000030_popcandy.45025cc9.png";